<div class="container pt-2">
    <!-- <div class="col-md-12">
       <h5> New petition {{ newPetitionCompanyName}} </h5>
    </div> -->
    <div class="col-md-12" *ngIf="isCreateAndEdit">
        <!-- <button class="im-btn im-btn-primary im-btn-md" (click)="createTask()">
            + Create New
        </button> -->
    </div>
    <div class="row col-md-12 mt-3">
        <div class="col-md-2">
            All Petition({{petitionCount}})
        </div>
        <div class="col-md-10">
            <div class="float-right col-md-6 row">
                <div class="col-md-2">
                    <label>Filter</label>
                </div>
                <div class="col-md-10">
                    <mat-form-field>
                        <input matInput (keyup)="applyFilter($event)">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="mat-elevation-z8">
        <table class="im-card-no-border-table" mat-table [dataSource]="dataSource" matSort>

            <!-- name Column -->
            <ng-container matColumnDef="name" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let element" > {{element.beneficiaryName}} </td>
            </ng-container>

            <!-- visaType Column -->
            <ng-container matColumnDef="petitionType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Petition Type </th>
                <td mat-cell *matCellDef="let element"> {{element.visaType.name}} </td>
            </ng-container>

            <!-- company Column -->
            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Company </th>
                <td mat-cell *matCellDef="let element"> {{element.companyname}} </td>
            </ng-container>

            <!-- dateFiled Column -->
            <ng-container matColumnDef="dateFiled">
                <th mat-header-cell *matHeaderCellDef> Date Filed </th>
                <td mat-cell *matCellDef="let element"> {{element.createdDate}} </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                    Action
                </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-button *ngIf="isViewPetition" class="mt-2 mb-2" (click)="handlePetition(row)">View Petiton</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="handleDblClick(row)"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[25, 50, 100]"></mat-paginator>
        <div class="mat-elevation-z8"></div>
    </div>


</div>
